export default __webpack_public_path__ + "static/media/truck-pup.b345337b.svg";